import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../../commons/app-commons.module';

import { ImageInfoDetailComponent } from './image-info-detail.component';

import { ImageInfoDetailBoxModule } from '../image-info-detail-box/image-info-detail-box.module';

/**
 * 画像情報詳細部品 モジュール設定クラス
 *
 * @export ImageInfoDetailModule
 * @class ImageInfoDetailModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    ImageInfoDetailBoxModule,
  ],
  declarations: [
    ImageInfoDetailComponent,
  ],
  providers: [
  ],
  exports: [
    ImageInfoDetailComponent
  ]
})
export class ImageInfoDetailModule {
}
